<template>
  <div class="w-full">
    <div class="flex justify-between" v-if="cornerHint || label">
      <label class="block text-sm font-medium" :class="labelStyling">{{
        label
      }}</label>
      <span
        class="text-sm text-gray-500"
        v-if="cornerHint"
        :class="cornerHintStyling"
        >{{ cornerHint }}</span
      >
    </div>
    <div
      class="relative rounded-md"
      :class="{
        'mt-1': cornerHint || label,
      }"
    >
      <slot name="leadingContent"></slot>
      <input
        ref="input"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        v-bind="$attrs"
        class="shadow-sm block w-full sm:text-sm rounded-md"
        :class="[
          { 'pr-10': invalid },
          finalInputFocusStyling +
            finalInputBorderStyling +
            finalInputTextStyling +
            inputStyling,
        ]"
      />
      <slot name="trailingContent"></slot>
      <div
        v-show="invalid && !$slots.trailingContent"
        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
        <ExclamationCircleIcon class="h-5 w-5 text-red-500" />
      </div>
    </div>
    <p
      class="mt-2 text-sm"
      :class="finalHelpStyling"
      v-if="help || (invalid && error)"
    >
      {{ finalHelpText }}
    </p>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  inheritAttrs: false,
  name: "UiInput",
  components: {
    ExclamationCircleIcon,
  },

  props: {
    modelValue: {
      type: [String, Number, null],
    },
    labelStyling: {
      type: String,
      default: "text-gray-700",
    },
    label: {
      type: String,
      required: false,
    },
    cornerHint: {
      type: String,
      required: false,
    },
    cornerHintStyling: {
      type: String,
      default: "text-gray-500",
    },
    helpStyling: {
      type: String,
      default: "text-gray-500",
    },
    inputFocusStyling: {
      type: String,
      default: "focus:ring-light-blue-600 focus:border-light-blue-600",
    },
    inputBorderStyling: {
      type: String,
      default: "border-gray-300",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      required: false,
    },
    help: {
      type: String,
      required: false,
    },
    inputStyling: {
      type: String,
      default: "",
    },
  },

  emits: ["update:modelValue"],

  computed: {
    finalInputFocusStyling() {
      var response = this.invalid
        ? "focus:outline-none focus:ring-red-500 focus:border-red-500"
        : this.inputFocusStyling;

      return this.classString(response);
    },

    finalInputBorderStyling() {
      var response = this.invalid ? "border-red-300" : this.inputBorderStyling;

      return this.classString(response);
    },

    finalInputTextStyling() {
      var response = this.invalid ? "text-red-900 placeholder-red-300" : "";

      return this.classString(response);
    },

    finalHelpStyling() {
      var response = this.invalid ? "text-red-600" : this.helpStyling;

      return this.classString(response);
    },

    finalHelpText() {
      return this.invalid ? this.error : this.help;
    },
  },

  methods: {
    classString(string) {
      return string + " ";
    },
  },
};
</script>